import { ButtonHTMLAttributes } from "react"
import IconSprite from "./IconSprite"

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: 'red' | 'white' | 'black' | 'yellow' | 'silver'
  icon?: 'bolt' | 'phone' | 'location'
  border?: boolean
  children?: React.ReactNode
  className?: string
  type?: 'button' | 'submit' | 'reset'
  onClick?: () => void
}

export default function Button({ children, color = 'yellow', icon, border, className, ...props }: Props) {

  if (className) {
    return (
      <button
        {...props}
        className={`inline-flex items-center px-4 py-2 min-w-fit truncate overflow-hidden ${className}`}>
        {
          icon && <IconSprite id={`ic_${icon}`} className="h-4 w-4 mr-2" />
        }
        {children}
      </button>
    )
  }

  return (
    <button
      {...props}
      className={`inline-flex items-center px-4 py-2 border-2 border-${color} hover:border-${color}-dark rounded-md shadow-sm ${border ? '' : 'bg-' + color} hover:bg-${color}-dark min-w-fit truncate overflow-hidden`}>
      {
        icon && <IconSprite id={`ic_${icon}`} className="h-4 w-4 mr-2" />
      }
      {children}
    </button>
  )
}
